import axios from "axios"
// import accessToken from "./jwt-token-access/accessToken"

//pass new generated access token here
const token = ""

//apply base url for axios
// const API_URL = "http://localhost:8000/api/"
// const CSRF_URL = "http://localhost:8000/"
const API_URL = "http://logbook_api.espls.in/api/"
const CSRF_URL = "http://logbook_api.espls.in/"

const axiosApi = axios.create({
  baseURL: API_URL,
})

const axiosCsrfApi = axios.create({
  baseURL: CSRF_URL,
  credentials: true,
})

// axiosApi.defaults.headers.common["Authorization"] = token
axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

// axiosCsrfApi.defaults.headers.common["Authorization"] = token
axiosCsrfApi.interceptors.response.use(
  response => {
    // console.log('intercepted', response);
    return response
  },
  error => Promise.reject(error)
)

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function getCsrf(url, config = {}) {
  return (
    await axiosCsrfApi.get(url, { ...config }).then(response => {
      console.log("csrf resp", response)
      return response.data
    }),
    { withCredentials: true }
  )
}

export async function post(url, data, config = {}) {
  // console.log(data);
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function postMultipart(url, data) {
  // console.log('APi Data', data);
  return (
    axiosApi
      // .post(url, {data: "test"}, {config: {headers: {"content-type": "multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s"}}})
      .post(
        url,
        data
        // {
        // headers: {
        //     // "content-type": 'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        //     // "Accept": "application/json"
        //     // "content-type": 'application/x-www-form-urlencoded'
        // }
        //   }
      )
      // .post(url, {data: data}, {headers: {"content-type": "multipart/form-data"}})
      .then(response => response.data)
  )
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}
